import { useEffect } from 'react';
import { useAuth } from '../../providers/AuthProvider';

export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading, roles } = useAuth();
    
    // Check if auth bypass is enabled for local testing
    const bypassAuth = process.env.REACT_APP_BYPASS_AUTH === 'true';

    const hasRoles = Array.isArray(roles) && roles.length > 0;

    useEffect(() => {
        // Skip redirect if auth is bypassed
        if (bypassAuth) {
            return;
        }
        
        if (!isLoading && !isAuthenticated) {
            window.location.href = '/auth/login';
            return;
        }

        if (!isLoading && isAuthenticated && !hasRoles) {
            window.location.href = '/no-permission';
        }
    }, [isAuthenticated, isLoading, hasRoles, bypassAuth]);

    // If auth is bypassed, render children immediately
    if (bypassAuth) {
        return children;
    }

    if (isLoading) {
        return null;
    }

    if (!isAuthenticated) return null;

    if (!hasRoles) return null;

    return children;
}; 